var React = require('react');

function AfiLogo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#e1251b;}")),React.createElement("g",{"id":"Capa_2","data-name":"Capa 2","key":1},React.createElement("g",{"id":"Layer_1","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M140.64,73.33c0-.5,0-1,0-1.53s0-1,0-1.48A70.32,70.32,0,0,0,0,70.32l0,70.32H111.79V111.79h28.89Zm-37.11,30.2H70.32a33.21,33.21,0,1,1,33.21-33.21Zm28.81-31.47c0,.46,0,.86,0,1.27v30.2H111.79V70.12a41.48,41.48,0,1,0-41.47,41.67h33.21v20.59H8.3l0-62.06a62.06,62.06,0,0,1,124.12,0c0,.43,0,.87,0,1.29v.45Z"})))]);
}

AfiLogo.defaultProps = {"viewBox":"0 0 140.68 140.64"};

module.exports = AfiLogo;

AfiLogo.default = AfiLogo;
